import { History, ShowChart } from "@mui/icons-material";
import { useSessionContext } from "../../contexts/SessionContext";
import { IFeatures } from "../../utils/interfaces";
import { ClinicalAnalysis } from "./ClinicalAnalysis";
import { currentFeatures } from "../../configs/Settings";
import { ManagerContextProvider } from "@/contexts/ManagerContext";

export function useClinicalAnalysis() {
  const { access } = useSessionContext();

  const configs: IFeatures = {
    active: access?.type === "professional" && currentFeatures.defaultApp,
    path: "/clinicalanalysis",
    icon: ShowChart,
    text: "Insights clínicos",

    subitem: true,
    parent: "Insights",

    sideMenu: true,
    sideMenuIndex: 0,

    avatarMenu: true,
    avatarIndex: 2,

    component: () => (
      <ManagerContextProvider>
        <ClinicalAnalysis />
      </ManagerContextProvider>
    ),
  };

  return configs;
}
